import React from 'react';
import PropTypes from 'prop-types';
import DashboardPrintHeader from './DashboardPrintHeader';
import './DashboardPrintable.css';

/**
 * Wraps the dashboard in a container that react-to-print can target.
 * The DashboardPrintHeader inside is a running header that repeats on
 * every printed page via `position: fixed` + @page margins.
 *
 * NOTE: react-to-print v2 requires the ref to be forwarded to the *root*
 * DOM node of the element being printed — hence forwardRef here.
 */
const DashboardPrintable = React.forwardRef(({ children }, ref) => (
  <div ref={ref} className="dashboard-printable">
    <DashboardPrintHeader />
    <div className="dashboard-printable__body">
      {children}
    </div>
  </div>
));

DashboardPrintable.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardPrintable;
